import { modifier } from '@styles/mixins'
import { colors, grid, typography } from '@styles/vars'
import styled, { css } from 'styled-components'
import { NotificationProps } from './'

export const Heading = styled.p`
    color: ${colors.black};
    font-size: ${typography.sizes.s};
    font-weight: 700;
    margin-bottom: 0;
`

export const Message = styled.p`
    color: ${colors.black};
    font-weight: 700;
    font-size: ${typography.sizes.s};
    line-height: 150%;
`

export const Close = styled.div`
    position: absolute;
    top: 8px;
    right: 15px;
    cursor: pointer;

    svg {
        fill: ${colors.black};
    }
`

export const Content = styled.div`
    display: flex;
    align-items: center;

    svg {
        fill: ${colors.black};
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        margin-right: 10px;
    }
`

type NotificationModifiers = Pick<NotificationProps, "type">

export default styled.div<NotificationModifiers>`
    position: relative;
    padding: 10px 30px 10px 15px;
    width: 400px;
    max-width: calc(100vw - ${grid.margins.phone});
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 10px;
    margin-top: calc(${grid.margins.phone} / 2);
    margin-right: calc(${grid.margins.phone} / 2);

    ${modifier("type:error", css`
        background: ${colors.errorBackground};
        border: 0;
    `)}
`